<template>
  <header class="custom-header">
    <div class="container">
      <div class="row align-items-center justify-content-between">
        <!-- Logo -->
        <div class="col-lg-2 col-md-3 col-12 text-center">
          <div class="logo">
            <img src="https://marketweb.9ood.net/assets/logo-head.png" alt="Sino Thai Trade" class="logo-img w-100">
          </div>
        </div>

        <!-- Search bar -->
        <div class="col-lg-6 col-md-5 col-12 d-flex align-items-center">
          <div class="search-bar">
            <input 
      type="text" 
      v-model="searchQuery" 
      class="form-control custom-search-input" 
      placeholder="Search" 
      @keyup.enter="submitSearch" 
    />
    <button class="btn custom-search-btn" @click="submitSearch">
      <i class="fas fa-search"></i>
    </button>
          </div>
        </div>

        <!-- Right side icons and text -->
        <div class="col-lg-4 col-md-4 col-12 d-flex justify-content-end align-items-center">
          <!-- Content for Desktop (PC) -->
          <div id="pc" class="d-none d-lg-flex justify-content-end align-items-center">
            <div class="icon-nav me-3">
              <i class="fas fa-qrcode"></i>
              <div class="icon-nav-text">
                Download the<br><span style="font-size:8px;">Sino Thai Trade App</span>
              </div>
            </div>

           <div class="language-selector dropdown me-3">
    <a href="#" class=" dropdown-toggle text-light" type="button" id="languageDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="fas fa-globe"></i> {{ currentLang === 'en' ? 'EN' : 'TH' }}
    </a>


        <ul class="dropdown-menu" aria-labelledby="languageDropdown">
          <li><a class="dropdown-item text-dark" href="#" @click.prevent="changeLang('th')" rel="noopener noreferrer">ไทย</a></li>
          <li><a class="dropdown-item text-dark" href="#" @click.prevent="changeLang('en')" rel="noopener noreferrer">English</a></li>
        </ul>




</div>

<div class="icon-nav me-3">
              <i class="fas fa-user"></i>
              <div class="icon-nav-text">
                <template v-if="email">
                    Welcome <a href="https://shop.sinothaitrade.com/Customer/getmember">
                        <span style="font-size:8px;">{{ email }}</span>
                    </a>
                </template>
                <template v-else>
                    Welcome <a href="https://shop.sinothaitrade.com/LoginPage">
                        <span style="font-size:8px;">Sign in / Register</span>
                    </a>
                </template>
              </div>
            </div>
  <a href="https://shop.sinothaitrade.com/index.php/show-cart">
            <div class="icon-nav text-center me-3">
             
              <i class="fas fa-shopping-cart"></i>
              <div class="icon-nav-text">
                <span :class="[
                    totalItems > 0 ? 'bg-danger text-light' : 'bg-light text-dark',
                    'rounded-pill'
                ]" 
                style="width:30px;">
                    {{ totalItems }}
                </span>
                <span style="font-size:8px; margin-top:3px;">Cart</span>
              </div>
              
            </div> 
            </a>
          </div>

          <div id="tablet" class="d-none d-md-block d-lg-none">
    <div class="row justify-content-center align-items-center">
        <div class="col-2 icon-nav text-center">
            <i class="fas fa-qrcode"></i>
        </div>

        <div class="col-4 dropdown text-center icon-nav mr-4">
    <a href="#" class="dropdown-toggle text-light" type="button" id="languageDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="fas fa-globe"></i> {{ currentLang === 'en' ? 'EN' : 'TH' }}
    </a>
    <ul class="dropdown-menu" aria-labelledby="languageDropdown">
        <li><a class="dropdown-item text-dark" href="#" @click.prevent="changeLang('th')" rel="noopener noreferrer">ไทย</a></li>
        <li><a class="dropdown-item text-dark" href="#" @click.prevent="changeLang('en')" rel="noopener noreferrer">English</a></li>
    </ul>
</div>


        <div class="col-2 icon-nav text-center ml-5">
          <a href="https://shop.sinothaitrade.com/index.php/Customer/getmember"> <i class="fas fa-user"></i></a>
        </div>
        <div  class="col-2 text-center">
        <a href="https://shop.sinothaitrade.com/index.php/checkout">
            <div class="icon-nav">
                <i class="fas fa-shopping-cart"></i>
            </div>
        </a></div>
    </div>
</div>




          <!-- Content for Mobile (เรียงไอคอนจากซ้ายไปขวา) -->
          <div id="mobile" class="d-flex justify-content-between align-items-center d-md-none w-100 mt-3">
            <div class="col d-flex justify-content-center" @click="toggleSidebar" id="sidebarToggle">
              <i class="fas fa-bars"></i>
            </div>
            <div class="col d-flex justify-content-center">
              <i class="fas fa-qrcode"></i>
            </div>
            <div class="col d-flex justify-content-center">
              <a href="#" @click.prevent="changeLang(currentLang === 'en' ? 'th' : 'en')" class="text-light">
                <i class="fas fa-globe"></i>
                <small style="font-size: 0.8em;">{{ currentLang === 'en' ? 'EN' : 'TH' }}</small>
              </a>
            </div>
            <div class="col d-flex justify-content-center">
              <a href="https://shop.sinothaitrade.com/Customer/getmember"><i class="fas fa-user"></i></a>
            </div>
            <div class="col d-flex justify-content-center">
              <a href="https://shop.sinothaitrade.com/index.php/checkout"><i class="fas fa-shopping-cart"></i></a>
            </div>
          </div>
        </div>
      </div>

      <div id="sidebar" class="sidebar shadow" :class="{ 'active': isSidebarOpen }">
  <button class="close-btn" @click="toggleSidebar">&times;</button>
  
  <!-- All Services Dropdown -->
  <div class="dropdown all-services d-none mt-5 mb-3 d-flex justify-content-center">
    <button class="btn dropdown-toggle btn-all-service d-none custom-dropdown w-100" 
            type="button" 
            style="margin-left: 20px;" 
            id="dropdownMenuButton" 
            data-bs-toggle="dropdown" 
            aria-expanded="false">
      <i class="fas fa-bars"></i> All Services
    </button>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <li><router-link class="dropdown-item" to="/all_services">Service 1</router-link></li>
      <li><router-link class="dropdown-item" to="/all_services">Service 2</router-link></li>
      <li><router-link class="dropdown-item" to="/all_services">Service 3</router-link></li>
    </ul>
  </div>

  <!-- Main Navigation -->
  <ul class="sidebar-nav">
    <li class="nav-item">
      <router-link class="sidebar-nav-link" 
                   :class="{ 'sidebar-active': $route.path === '/' }" 
                   to="/" 
                   @click="toggleSidebar">
        <i class="fas fa-home me-2"></i>Home
      </router-link>
    </li>
    
    <li class="nav-item">
      <router-link class="sidebar-nav-link" 
                   :class="{ 'sidebar-active': $route.path === '/about' }" 
                   to="/about" 
                   @click="toggleSidebar">
        <i class="fas fa-info-circle me-2"></i>About
      </router-link>
    </li>
    
    <!-- Products with Submenu -->
    <li class="nav-item has-submenu">
      <a class="sidebar-nav-link" 
         :class="{ 'sidebar-active': $route.path.includes('/product') }"
         @click="toggleSubmenu($event)">
        <i class="fas fa-box me-2"></i>Products
        <i class="fas fa-chevron-down float-end submenu-arrow"></i>
      </a>
    
      
      <ul class="submenu">
  <li v-for="category in categories" :key="category.category_id">
    <a :href="'https://shop.sinothaitrade.com/shop/category_view/' + category.category_id" target="_blank" @click="toggleSidebar">
      <i class="fas fa-cogs me-2"></i>
      {{ category.category_name }}
      <small class="d-block text-muted" v-if="category.sub_categories && category.sub_categories.length > 0">
        <span v-for="(sub_category, index) in category.sub_categories" :key="sub_category.sub_cat_id">
          {{ sub_category.sub_category_name }}
          <!-- ใส่เครื่องหมายคอมม่าไม่ให้แสดงในรายการสุดท้าย -->
          <span v-if="index < category.sub_categories.length - 1">, </span>
        </span>
      </small>
    </a>
  </li>
</ul>


    </li>


<!-- Community Submenu -->
<li class="nav-item has-submenu">
  <a class="sidebar-nav-link" 
     :class="{ 'sidebar-active': $route.path.includes('/community') }"
     @click="toggleSubmenu($event)">
    <i class="fas fa-users me-2"></i>Community
    <i class="fas fa-chevron-down float-end submenu-arrow"></i>
  </a>
  <ul class="submenu">
   
    <li>
      <a href="https://blog.sinothaitrade.com/blog/category/news-updates" @click="toggleSidebar">
        <i class="fas fa-newspaper me-2"></i>
        News & Updates
        <small class="d-block text-muted">ข่าวสารและอัพเดท</small>
      </a>
    </li>
    <li>
      <a href="https://blog.sinothaitrade.com/blog/category/events" @click="toggleSidebar">
        <i class="fas fa-calendar-alt me-2"></i>
        Events
        <small class="d-block text-muted">กิจกรรมต่างๆ</small>
      </a>
    </li>
    <li>
      <a href="https://blog.sinothaitrade.com/blog/category/forum" @click="toggleSidebar">
        <i class="fas fa-comments me-2"></i>
        Forum
        <small class="d-block text-muted">เวทีแลกเปลี่ยนความคิดเห็น</small>
      </a>
    </li>
  </ul>
</li>

<!-- Services Submenu -->
<li class="nav-item has-submenu">
  <a class="sidebar-nav-link" 
     :class="{ 'sidebar-active': $route.path.includes('/services') }"
     @click="toggleSubmenu($event)">
    <i class="fas fa-concierge-bell me-2"></i>Services
    <i class="fas fa-chevron-down float-end submenu-arrow"></i>
  </a>
  <ul class="submenu">
    <li>
      <a href="https://blog.sinothaitrade.com/blog/category/trade-logistics" @click="toggleSidebar">
        <i class="fas fa-truck-moving me-2"></i>
        Trade Logistics
        <small class="d-block text-muted">การขนส่งการค้า</small>
      </a>
    </li>
    <li>
      <a href="https://blog.sinothaitrade.com/blog/category/transaction-and-payment" @click="toggleSidebar">
        <i class="fas fa-money-check-alt me-2"></i>
        Transaction and Payment
        <small class="d-block text-muted">การโอนเงินและการจ่ายเงิน</small>
      </a>
    </li>
    <li>
      <a href="https://blog.sinothaitrade.com/blog/category/guarantee-and-authorization" @click="toggleSidebar">
        <i class="fas fa-certificate me-2"></i>
        Guarantee and Authorization
        <small class="d-block text-muted">การรับรองและการอนุญาตสินค้า</small>
      </a>
    </li>
  </ul>
</li>
</ul>
</div>

      <!-- Navigation Menu -->
      <div class="row mt-3 d-none d-md-block">
        <div class="col-md-12 d-flex align-items-center justify-content-between">
          <!-- Hamburger menu button -->
          <div class="dropdown all-services">
            <button class="btn dropdown-toggle d-none custom-dropdown btn-sm w-20" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="fas fa-bars"></i> All Services
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <li><router-link class="dropdown-item text-dark" to="/all_services">Service 1</router-link></li>
              <li><router-link class="dropdown-item text-dark" to="/all_services">Service 2</router-link></li>
              <li><router-link class="dropdown-item text-dark" to="/all_services">Service 3</router-link></li>
            </ul>
          </div>

          <!-- Main navigation -->
          <nav class="main-nav">
          



 <ul class="nav justify-content-center">
              <li class="nav-item mr-3">
                <router-link class="nav-link" :class="{ active: $route.path === '/' }" to="/"><i class="fas fa-home me-2"></i> Home</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :class="{ active: $route.path === '/about' }" to="/about">About</router-link>
              </li>
              <li class="nav-item dropdown">
  <router-link class="nav-link dropdown-toggle" 
               :class="{ active: $route.path === '/product' }" 
               to="/product"
               role="button"
               data-bs-toggle="dropdown"
               aria-expanded="false">
    Products
  </router-link>
  <ul class="dropdown-menu">
  <li v-for="category in categories" :key="category.category_id">
    <a class="dropdown-item" :href="'https://shop.sinothaitrade.com/shop/category_view/' + category.category_id">
      <i class="fas fa-cogs me-2"></i>
      {{ category.category_name }}
     
    
    
      <small class="d-block text-muted" v-if="category.sub_categories && category.sub_categories.length > 0">
  <span v-for="(sub_category, index) in category.sub_categories" :key="sub_category.sub_cat_id">
    {{ sub_category.sub_category_name }}
    <!-- ใส่เครื่องหมายคอมม่าไม่ให้แสดงในรายการสุดท้าย -->
    <span v-if="index < category.sub_categories.length - 1">, </span>
  </span>
</small>

    </a>
  </li>
</ul>

</li>
  <li class="nav-item dropdown">
    <router-link class="nav-link dropdown-toggle" 
                 :class="{ active: $route.path.includes('/community') }" 
                 to="/community"
                 role="button"
                 data-bs-toggle="dropdown"
                 aria-expanded="false">
      Community
    </router-link>
    
    <ul class="dropdown-menu">
      <li>
        <a href="https://blog.sinothaitrade.com/blog/category/news-updates" class="dropdown-item">
          <i class="fas fa-newspaper me-2"></i>
          News & Updates
          <small class="d-block text-muted">ข่าวสารและอัพเดท</small>
        </a>
      </li>
      <li>
        <a href="https://blog.sinothaitrade.com/blog/category/events" class="dropdown-item">
          <i class="fas fa-calendar-alt me-2"></i>
          Events
          <small class="d-block text-muted">กิจกรรมต่างๆ</small>
        </a>
      </li>
      <li>
        <a href="https://blog.sinothaitrade.com/blog/category/forum" class="dropdown-item">
          <i class="fas fa-comments me-2"></i>
          Forum
          <small class="d-block text-muted">เวทีแลกเปลี่ยนความคิดเห็น</small>
        </a>
      </li>
    </ul>
  </li>

  <!-- Academy Dropdown -->
  <li class="nav-item dropdown">
    <router-link class="nav-link dropdown-toggle" 
                 :class="{ active: $route.path.includes('/academy') }" 
                 to="/academy"
                 role="button"
                 data-bs-toggle="dropdown"
                 aria-expanded="false">
      Academy
    </router-link>
    
    <ul class="dropdown-menu">
      <li>
        <a href="https://blog.sinothaitrade.com/blog/category/online-training" class="dropdown-item">
          <i class="fas fa-laptop me-2"></i>
          Online Training
          <small class="d-block text-muted">การอบรมออนไลน์</small>
        </a>
      </li>
      
      <li>
        <a href="https://blog.sinothaitrade.com/blog/category/offline-training" class="dropdown-item">
          <i class="fas fa-chalkboard-teacher me-2"></i>
          Offline Training
          <small class="d-block text-muted">การอบรมแบบปกติ</small>
        </a>
      </li>
      
      <li>
        <a href="https://blog.sinothaitrade.com/blog/category/process-for-trading" class="dropdown-item">
          <i class="fas fa-exchange-alt me-2"></i>
          Process for Trading
          <small class="d-block text-muted">กระบวนการสำหรับการค้า</small>
        </a>
      </li>
      
      <li>
        <a href="https://blog.sinothaitrade.com/blog/category/related-departments" class="dropdown-item">
          <i class="fas fa-building me-2"></i>
          Related Departments
          <small class="d-block text-muted">หน่วยงานที่เกี่ยวข้อง</small>
        </a>
      </li>
    </ul>
  </li>

  <!-- Services Dropdown -->
  <li class="nav-item dropdown">
    <router-link class="nav-link dropdown-toggle" 
                 :class="{ active: $route.path.includes('/services') }" 
                 to="/services"
                 role="button"
                 data-bs-toggle="dropdown"
                 aria-expanded="false">
      Services
    </router-link>
    
    <ul class="dropdown-menu">
      <li>
        <a href="https://blog.sinothaitrade.com/blog/category/trade-logistics" class="dropdown-item">
          <i class="fas fa-truck-moving me-2"></i>
          Trade Logistics
          <small class="d-block text-muted">การขนส่งการค้า</small>
        </a>
      </li>
      
      <li>
        <a href="https://blog.sinothaitrade.com/blog/category/transaction-and-payment" class="dropdown-item">
          <i class="fas fa-money-check-alt me-2"></i>
          Transaction and Payment
          <small class="d-block text-muted">การโอนเงินและการจ่ายเงิน</small>
        </a>
      </li>
      
      <li>
        <a href="https://blog.sinothaitrade.com/blog/category/guarantee-and-authorization" class="dropdown-item">
          <i class="fas fa-certificate me-2"></i>
          Guarantee and Authorization
          <small class="d-block text-muted">การรับรองและการอนุญาตสินค้า</small>
        </a>
      </li>
    </ul>
  </li>
</ul>
          </nav>
        </div>
      </div>
    </div>
  </header>

  <main class="container-fluid m-0 p-0" style="min-height:500px;">
      <router-view></router-view>
    </main>



        <!-- Footer -->
        <footer class="bg-dark text-white pt-4">
        <div class="container">
            <div class="row">
                <!-- Company Info -->
                <div class="col-md-4 col-12">
                    <h5 class="mb-3">Sino Thai Trade</h5>
                   
                    <div class="footer-images">
                        <img src="https://shop.sinothaitrade.com/assets/footer/image01.png" alt="Company Logo" class="footer-logo">
                        <img src="https://shop.sinothaitrade.com/assets/footer/image02.png" alt="Company Logo" class="footer-logo">
                        <img src="https://shop.sinothaitrade.com/assets/footer/image03.png" alt="Company Logo" class="footer-logo">
                    </div>
                    

                </div>

                <!-- Quick Links -->
                <div class="col-md-4 col-12">
                    <h5 class="mb-3">Quick Links</h5>
                    <ul class="list-unstyled">
                        <li><a href="#" class="text-white text-decoration-none">Home</a></li>
                        <li><a href="#" class="text-white text-decoration-none">About Us</a></li>
                        <li><a href="#" class="text-white text-decoration-none">Products</a></li>
                        <li><a href="#" class="text-white text-decoration-none">Services</a></li>
                    </ul>
                </div>

                <!-- Contact Info -->
                <div class="col-md-4 col-12">
                    <h5 class="mb-3">Contact Us</h5>
                    การพัฒนานโยบายด้านการค้า การลงทุนรูปแบบใหม่เพื่อสนับสนุนและส่งเสริมการค้าและลงทุนในพื้นที่ระเบียงเศรษฐกิจ ระหว่างไทย-จีน
                    <p><i class="fas fa-map-marker-alt"></i>ที่อยู่ มหาวิทยาลัยขอนแก่น 123 ม.16 ถนนมิตรภาพ ต.ในเมือง อ.เมือง จ.ขอนแก่น 40000</p>
                    <p><i class="fas fa-envelope"></i>sinothaitrade@gmail.com</p>
                </div>
            </div>

            <!-- Social Media Links -->
            <div class="row mt-4">
                <div class="col-md-12 text-center">
                    <a href="#" class="text-white mx-2"><i class="fab fa-facebook-f"></i></a>
                    <a href="#" class="text-white mx-2"><i class="fab fa-twitter"></i></a>
                    <a href="#" class="text-white mx-2"><i class="fab fa-linkedin-in"></i></a>
                    <a href="#" class="text-white mx-2"><i class="fab fa-instagram"></i></a>
                </div>
            </div>

            <!-- Footer Bottom -->
            <div class="row mt-4">
                <div class="col-md-12 text-center">
                    <p>&copy; 2024 Sino Thai Trade. All Rights Reserved.</p>
                </div>
            </div>
        </div>
    </footer>




</template><script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      categories: [],
      isSidebarOpen: false,
      searchQuery: '',
      totalItems: 0,
      email: '',
      currentLang: 'th' // Default language
    };
  },
  methods: {
     fetchCategories() {
      fetch("https://shop.sinothaitrade.com/menu_api/get_menu")
        .then((response) => response.json())
        .then((data) => {
          this.categories = data;
          console.log(this.categories);
        })
        .catch((error) => {
          console.error("Error fetching categories:", error);
        });},
    toggleSubmenu(event) {
      const parent = event.target.closest('.has-submenu');
      parent.classList.toggle('open');
    },
    submitSearch() {
      if (this.searchQuery.trim()) {
        // Redirect to the search results page with the search query
        window.location.href = `https://shop.sinothaitrade.com/shop/search_result?search=${encodeURIComponent(this.searchQuery)}`;
      }
    },
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    // Method to get the value of a cookie by name
    getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
},

setCookie(name, value, days = 365) {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
},
    // Method to fetch total items and email from cookies
    fetchFromCookies() {
      // Get total items from cookie
      const cartQty = this.getCookie('cart_qty');
      this.totalItems = cartQty ? parseInt(cartQty) : 0; // Set total items

      // Get email from cookie
      const email = this.getCookie('email');
      this.email = email ? email : ''; // Set email

      console.log("Email:", this.email);
      console.log("Total Items in Cart:", this.totalItems);
    },
    changeLang(lang) {
  this.currentLang = lang;
  // Save language preference in cookie
  this.setCookie('site_lang', lang);
  // Update URL with new language parameter
  const url = new URL(window.location.href);
  url.searchParams.set('lang', lang);
  window.location.href = url.toString();
},
    // Initialize language from URL parameter
    initLang() {
  // First check cookie
  const siteLang = this.getCookie('site_lang');
  if (siteLang) {
    this.currentLang = siteLang;
  } else {
    // If no cookie, check URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang');
    if (lang) {
      this.currentLang = lang;
      this.setCookie('site_lang', lang);
    }
  }
}
  },
  mounted() {
    this.fetchFromCookies();
    this.initLang(); // Initialize language when component mounts
  },
  created() {
    this.fetchCategories();
  },
};
</script>




<style>
body {
    font-family: 'Kanit', sans-serif;
}

/* Download app section */
.download-app {
    display: flex;
    align-items: center;
}

.download-app i {
    font-size: 24px;
    margin-right: 10px;
}

.download-text {
    font-size: 12px;
    line-height: 1.2;
    display: flex;
    flex-direction: column;
}

  /* Download app section */
  .icon-nav {
    display: flex;
    align-items: center;
}

.icon-nav i {
    font-size: 24px;
    margin-right: 10px;
}



.icon-nav-text {
    font-size: 12px;
    line-height: 1.2;
    display: flex;
    flex-direction: column;
}

/* Header styles */
.custom-header {
background: linear-gradient(90deg, #0D8BC7 0%, #1E6598 100%);
padding: 15px 0;
color: white;
}
.logo-img {
    max-width: 320px;
}

.all-services {
    margin-right: 20px;
}

.custom-dropdown {
    background: white;
    color: #333;
    border: none;
    padding: 10px 15px;
    border-radius: 50px;
}

.search-bar {
    position: relative;
    flex-grow: 1;
}

.custom-search-input {
    border-radius: 50px;
    padding: 10px 20px;
    width: 100%;
}

.custom-search-btn {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    color: #333;
}

.download-app, .language-selector, .user-auth, .cart {
    margin-left: 20px;
    color: white;
}

.download-app i, .language-selector i, .user-auth i, .cart i {
    margin-right: 5px;
}

.language-selector i.fa-chevron-down {
    margin-left: 5px;
}

a {
    color: white;
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}

/* Main navigation */
.main-nav .nav-link {
    color: white;
    font-size: 16px;
    padding: 10px 20px;
}

.main-nav .nav-link:hover {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 5px;
}

.main-nav .nav-link.active {
    font-weight: bold;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 5px;
}

.main-nav {
    flex-grow: 1;
    display: flex;
    justify-content: center;
}

/* Body section */
.background-image {
    width: 100%;
    height: 85vh;
    background-image: url('@/assets/bg-main.png');
    background-size: cover;
    background-position: 85%;
    background-repeat: no-repeat;
}

.branding img {
    width: 100%;
}

.description {
    text-align: left;
    margin-top: 20px;
    color: #444;
    font-size:22px;
}

.auth-buttons {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    gap: 10px;
}

.auth-buttons .btn {
    width: 120px;
}

.social-login {
    text-align: center;
    margin-top: 15px;
}

.social-login .btn {
    margin: 0 5px;
}

@media (max-width: 820px) {
    .search-bar {
        width: 100%;
    }

    .logo-img {
        max-width: 270px;
        margin:15px;
    }

    .auth-buttons .btn {
        width: 100px;
    }

    .main-nav .nav-link {
        padding: 5px 10px;
    }

    .description {
        text-align: center;
    }

    .download-app {
        justify-content: center;
    }
}


/* Sidebar styling */
.sidebar {
height: 100%;
width: 250px;
position: fixed;
top: 0;
left: -250px; /* เริ่มต้นซ่อน sidebar */
background-color: #f8f9fa;
overflow-x: hidden;
transition: left 0.3s ease-in-out;
padding-top: 20px;
z-index: 1060;
}

.sidebar.active {
  left: 0; /* แสดง sidebar เมื่อ active */
}

.sidebar ul {
padding-left: 0;
}

.sidebar ul li {
padding: 4px 8px;
list-style-type: none;
}

.sidebar ul li a {
text-decoration: none;
color: #0D8BC7;
display: block;
}

.close-btn {
position: absolute;
top: 10px;
right: 20px;
font-size: 24px;
background: none;
border: none;
cursor: pointer;
}

.close-btn:hover {
color: #ff0000;
}


/* Style for the floating button */
#sidebarToggle {
/* position: fixed;*/
top: 20px; /* Adjust distance from top */
left: 20px; /* Adjust distance from left */
z-index: 1050; /* Ensure it stays above other content */
color: white;
}

/* สำหรับหน้าจอขนาดเล็ก เช่น มือถือ */
@media (max-width: 768px) {

  .custom-search-btn {
    position: absolute;
    right: 10px;
    top: 40%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    color: #333;
}
.background-image {
/*background-position: right; */
height:75vh;
}

.background-image img {
margin:40px;
width:90%;
}

.branding {
text-align: center;
}
}


#preloader {
position: fixed;
width: 100%;
height: 100%;
background-color: white;
z-index: 9999;
display: flex;
justify-content: center;
align-items: center;
}

body.loading #preloader {
color:#1280BA;
display: flex;
}

body.loaded #preloader {
display: none;
}

.bg-dark-blue{
background-color:#003E77;
color:#fff;
}

.btn-all-service{

  background: linear-gradient(90deg, #349E6D 0%, #3AAD62 100%);
    padding: 15px 0;
    color: white;
}


.sidebar-nav-link{
  padding:8px 16px; color: #0D8BC7;border-radius: 4px;
}
.sidebar-nav-link.sidebar-active {
    background-color: #0D8BC7;
    color: white;
    border-radius: 4px;

}
</style>


<style>
.dropdown-menu {
  border: none;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  border-radius: 12px;
  padding: 1rem 0;
  min-width: 300px;
}

.dropdown-item {
  padding: 0.75rem 1.5rem;
  transition: all 0.2s;
  color: #38A866 !important;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
  padding-left: 2rem;
}

.dropdown-item i {
  color: #0B8AC6;
}

.dropdown-item small {
  font-size: 0.8rem;
  margin-top: 0.25rem;
}

/* เพิ่ม animation เมื่อ dropdown แสดง */
.dropdown-menu.show {
  animation: slideIn 0.2s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>


<style>
.has-submenu {
  position: relative;
}

.submenu {
  display: none;
  list-style: none;
  padding-left: 2rem;
  margin: 0;
  background: rgba(0,0,0,0.02);
  border-left: 3px solid #0B8AC6;
}

.has-submenu.open .submenu {
  display: block;
}

.submenu li a {
  display: block;
  padding: 0.75rem 1rem;
  color: #666;
  text-decoration: none;
  transition: all 0.2s;
}

.submenu li a:hover {
  background: rgba(11,138,198,0.1);
  padding-left: 1.5rem;
}

.submenu-arrow {
  transition: transform 0.2s;
}

.has-submenu.open .submenu-arrow {
  transform: rotate(180deg);
}

.submenu small {
  font-size: 0.8rem;
  opacity: 0.7;
}
</style>
<style>
.footer-images {
    display: flex;
    gap: 15px;
    align-items: center;
}

.footer-logo {
    width: 100px;
    height: 50px;
    object-fit: contain;
    border-radius: 10px;
    padding: 5px;
    background-color: white;
}
</style>